export default __webpack_public_path__ + "static/Calibre-Regular-b0d4cbb1201155ddccc21d1b8059a670.woff2";